import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

export interface HelpCenterState {
	/** Whether the slide-in help chat panel is open. */
	isPanelOpen: boolean;
	/**
	 * A question queued for the AI chat (e.g. from a quick-question chip). HelpChat consumes and
	 * sends it as soon as the panel opens.
	 */
	pendingQuestion: string | null;
}

const initialState: HelpCenterState = {
	isPanelOpen: false,
	pendingQuestion: null,
};

export const helpCenterSlice = createSlice({
	name: "helpCenter",
	initialState,
	reducers: {
		/** Open the help panel, optionally queueing a question for the chat to send. */
		openHelpPanel: (state, action: PayloadAction<string | undefined>) => {
			state.isPanelOpen = true;
			state.pendingQuestion = action.payload ?? null;
		},
		closeHelpPanel: (state) => {
			state.isPanelOpen = false;
		},
		/** Called by the chat once it has picked up (and sent) the queued question. */
		consumePendingQuestion: (state) => {
			state.pendingQuestion = null;
		},
	},
});

export const { openHelpPanel, closeHelpPanel, consumePendingQuestion } = helpCenterSlice.actions;

export const helpCenterReducer = helpCenterSlice.reducer;

export const helpCenterSelector = (state: RootState): HelpCenterState =>
	state[helpCenterSlice.name];
